import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Typography, Divider, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import FileUploadButton from '../Form/FileUploadButton';

const useStyles = makeStyles((theme: Theme) => ({
  profileDataContainer: {
    padding: theme.spacing(3),
  },
  profileDetailsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
    },
  },
  profileImage: {
    height: '140px',
    width: '140px',
    backgroundPosition: 'center center',
    borderRadius: '13px',
    flexShrink: '0',
    backgroundColor: theme.palette.action.disabled,
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  profileName: {
    marginBottom: theme.spacing(1),
    wordWrap: 'break-word',
  },
  profileDesignation: {
    color: theme.palette.action.active,
  },
  profileDetails: {
    textAlign: 'center',
  },
  profileImageControls: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: theme.spacing(3),
  },
}));

const UserDetails = ({
  firstName,
  lastName,
  designation,
  profileImageUrl,
  onImageUpload,
  onImageRemove,
}: {
  firstName: string;
  lastName: string;
  designation: string;
  profileImageUrl: string;
  onImageUpload: () => void;
  onImageRemove: () => void;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Paper className={classes.profileDataContainer}>
      <div className={classes.profileDetailsWrapper}>
        <div className={classes.profileDetails}>
          {firstName || lastName ? (
            <Typography className={classes.profileName} variant="h5">
              {`${firstName} ${lastName}`}
            </Typography>
          ) : null}

          {designation ? (
            <Typography className={classes.profileDesignation}>
              {designation}
            </Typography>
          ) : null}
        </div>
        <div
          className={classes.profileImage}
          style={{
            backgroundImage: `url(${profileImageUrl})`,
          }}
        ></div>
      </div>
      <Divider orientation="horizontal" />
      <div className={classes.profileImageControls}>
        <FileUploadButton
          id="user-profile-picture-upload"
          label="Upload image"
          handleChange={onImageUpload}
          variant="contained"
          fullWidth
        />
        <Button onClick={onImageRemove}>{t('remove_photo')}</Button>
      </div>
    </Paper>
  );
};

export default memo(UserDetails);
